import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    public afs: AngularFirestore,   // Inject Firestore service
    private http: HttpClient,
  ) { }

  getUserProfile() {
    let uid = JSON.parse(localStorage.getItem('user')).uid;
    return this.afs.collection('users').doc(uid).snapshotChanges()
  }

  getUserProfilePromise() : Promise<any> {
    const uid = JSON.parse(localStorage.getItem('user')).uid;
    const userDocRef = this.afs.collection('users').doc(uid);
  
    return userDocRef.get().toPromise();
  }

  updateProfile(profile) {
    let uid = JSON.parse(localStorage.getItem('user')).uid;
    profile.updated = new Date();
    return this.afs
      .collection('users')
      .doc(uid)
      .set(profile, { merge: true });

  }

  getCountries() {
    return this.http.get('/assets/countries.json');
  }

}
